import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import React, { useMemo } from 'react';
import { Flex } from '../Flex';
import * as styles from './Card.styles';
/**
 * @param {import('@wp-g2/create-styles').ViewOwnProps<import('./types').CardFooterProps, 'div'>} props
 * @param {import('react').Ref<any>} forwardedRef
 */

function CardFooter(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'CardFooter'),
      className = _useContextSystem.className,
      _useContextSystem$jus = _useContextSystem.justify,
      justify = _useContextSystem$jus === void 0 ? 'flex-end' : _useContextSystem$jus,
      _useContextSystem$siz = _useContextSystem.size,
      size = _useContextSystem$siz === void 0 ? 'medium' : _useContextSystem$siz,
      otherProps = _objectWithoutProperties(_useContextSystem, ["className", "justify", "size"]);

  var classes = useMemo(function () {
    return cx(styles.borderRadius, styles.headerFooter, styles[size], className);
  }, [className, size]);
  return /*#__PURE__*/React.createElement(Flex, Object.assign({}, otherProps, {
    className: classes,
    justify: justify,
    ref: forwardedRef
  }));
}
/**
 * `CardFooter` is a layout component, rendering the footer content of a `Card`.
 *
 * @example
 * ```jsx
 * <Card>
 * 	<CardBody>...</CardBody>
 * 	<CardFooter>...</CardFooter>
 * </Card>
 * ```
 */


var ConnectedCardFooter = contextConnect(CardFooter, 'CardFooter');
export default ConnectedCardFooter;